module.exports = __webpack_public_path__ + "assets/56fc167586682935d8d0b72bd00aed230.jpg";